(ns frontend.view.grid.zap-vaults-grid.model)

(def root-path [::state])

(def search-text-key :search-text)
(def search-text-full-path (into root-path [search-text-key]))

(def show-inactive-key :show-inactive?)
(def show-inactive-full-path (into root-path [show-inactive-key]))

(def show-only-my-key :show-only-my?)
(def show-only-my-full-path (into root-path [show-only-my-key]))

(def loading-key :loading?)
(def loading-full-path (into root-path [loading-key]))
